import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { columnsAlumnosAllMonths } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCuotasAllMonth } from 'data/apiConection.js/dataCuotas.js';
import { FaFileExport } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const TableCuotasAllMonth = () => {
  const [cuotas, setCuotas] = useState([]);
  const [filteredCuotas, setFilteredCuotas] = useState([]);
  const [valueFilter, setValueFilter] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cu = await dataCuotasAllMonth();
        setCuotas(cu);
        setFilteredCuotas(cu); // Guardar copia original
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  // Filtrar en tiempo real
  useEffect(() => {
    if (!valueFilter.trim()) {
      setFilteredCuotas(cuotas);
      return;
    }

    const filterLower = valueFilter.toLowerCase();
    const cuotasFiltradas = cuotas.filter(c =>
      (c.dni && c.dni.toLowerCase().includes(filterLower)) ||
      (c.firstName && c.firstName.toLowerCase().includes(filterLower)) ||
      (c.lastName && c.lastName.toLowerCase().includes(filterLower))
    );
    setFilteredCuotas(cuotasFiltradas);
  }, [valueFilter, cuotas]);

  const export_excel = (dataToExport) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumnos Filtrados');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'estado_cuotas.xlsx');
  };

  const handle_export = () => {
    try {
      filteredCuotas && export_excel(filteredCuotas); // Exportar solo los filtrados
    } catch (error) {
      console.error(error);
    }
  };

  const columns = columnsAlumnosAllMonths();

  return (
    <div>
      <Row
        className="gx-4 mx-0"
        style={{
          height: '100vh',
          width: '100%',
          marginLeft: '250px',
          padding: '20px',
        }}
      >
        {filteredCuotas && (
          <Col style={{ height: '100%' }}>
            <AdvanceTableWrapper
              columns={columns}
              data={filteredCuotas}
              selectionColumnWidth={52}
              sortable
              pagination
              perPage={100}
              rowCount={filteredCuotas.length}
            >
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Card.Header>
                        <Row className="mb-3">
        <Col lg={10}>
          <label>Filtro</label>
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por DNI, Nombre o Apellido..."
            value={valueFilter}
            onChange={(e) => setValueFilter(e.target.value)}
          />
        </Col>
        <Col className="d-flex align-items-end">
          <Button onClick={handle_export}>
            <FaFileExport /> Exportar
          </Button>
        </Col>
      </Row>
                </Card.Header>
                <Card.Body className="p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
                  <AdvanceTable
                    table
                    headerClassName="bg-light text-800 align-middle"
                    rowClassName="btn-reveal-trigger align-middle"
                    tableProps={{
                      size: 'sm',
                      className: 'fs--1 mb-0 w-100 h-100',
                    }}
                  />
                </Card.Body>
                <Card.Footer>
                  <AdvanceTablePagination table />
                </Card.Footer>
              </Card>
            </AdvanceTableWrapper>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TableCuotasAllMonth;
